import React from "react";
import { Form, Button } from "react-bootstrap";
import { _t } from "../../app/i18n/i18n";
import { NomuraLogo } from "./NomuraLogo";
import { doResetPw } from "./api/doResetPw";
import { Link } from "react-router-dom";
import { ErrorMsg } from "./ChangePassword";

export const ForgottenPassword = ({ location }) => {
  return (
    <section className="w-100 screen-height text-white bg-dark p-5">
      <Form className="maxw-600" onSubmit={(e) => handleResetPwClick(e)}>
        <NomuraLogo />
        <p className="text-center font-weight-lighter h5">{_t("Forgotten your password?")}</p>

        <Form.Group className="mt-5">
          <Form.Label>{_t("Email address")}</Form.Label>
          <Form.Control
            type="email"
            name="userName"
            placeholder={_t("Enter email")}
            className="more-border-radius"
            defaultValue={""}
          />
          <Form.Text>{_t("Your password reset link will be sent to you by email later.")}</Form.Text>
        </Form.Group>

        <Button variant="outline-light my-3" className="w-100 more-border-radius" type="submit">
          {_t("Send me password reset link by email")}
        </Button>

        <Button
          variant="outline-secondary mb-3"
          className="w-100 more-border-radius"
          onClick={() => window.history.back()}
        >
          {_t("Back")}
        </Button>

        {location.search.includes("fail") && (
          <ErrorMsg
            title={_t("Error Logging In")}
            body={_t("A server error has occurred. Please wait a few moments, and try again.")}
          />
        )}
        {location.search.includes("invalid-token") && (
          <ErrorMsg title={_t("Your password reset request has expired")} body={_t("Please request a new password")} />
        )}
        {location.search.includes("invalid-update") && (
          <ErrorMsg title={_t("We were unable to update your password")} body={_t("Please request a new password")} />
        )}
        {location.search.includes("jpn-gi") && (
          <ErrorMsg
            title={_t("The Global Research Portal is not available for your account.")}
            body={_t(
              "The Global Research Portal is for Professional Investors. If you have any questions regarding this service, please contact Nomura Sales."
            )}
          />
        )}

        <Link to="/public/login-support" className="w-100 text-white text-center d-block my-1">
          {_t("Need Support?")}
        </Link>
      </Form>
    </section>
  );
};

const handleResetPwClick = (e) => {
  e.preventDefault();
  const form = e.target;
  //window.userName = form.userName.value;
  doResetPw(form.userName.value);
};
